import React from 'react';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import '../src/assets/css/style.css';
import 'react-toastify/dist/ReactToastify.css';

import {QueryClientProvider, QueryClient} from 'react-query';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "auth/authAzure";

import GlobalStyle from 'globalStyles';

const queryClient = new QueryClient();
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <MsalProvider instance={ msalInstance }>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
               <App/>
                <GlobalStyle />
            </QueryClientProvider>
        </BrowserRouter>
    </MsalProvider>
    ,
    document.getElementById('root')
);

/*
import React from 'react';

import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

//import { ReactQueryDevtools } from 'react-query/devtools'
import '../src/assets/css/style.css';
import 'react-toastify/dist/ReactToastify.css';

import {QueryClientProvider, QueryClient} from 'react-query';
import {AuthProvider} from "./store/providers/app";

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "auth/authAzure";

const queryClient = new QueryClient();
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
    <MsalProvider instance={ msalInstance }>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <App />
                </AuthProvider>
                {/!*  <ReactQueryDevtools initialIsOpen={false} />*!/}
            </QueryClientProvider>
        </BrowserRouter>
    </MsalProvider>
    ,
    document.getElementById('root')
);
*/
